import { Component } from '@angular/core';

@Component({
  selector: 'mode-error-prompt-actions',
  templateUrl: './error-prompt-actions.component.html',
  styleUrls: ['./error-prompt-actions.component.scss'],
})
export class ErrorPromptActionsComponent {
  constructor() {}
}
